import axios from 'axios';
import {
  RULES_STORES_FETCH_REQUEST,
  RULES_STORES_FETCH_SUCCESS,
  RULES_STORES_FETCH_FAILURE,
} from '../constants';
import { getAuthHeaders, getBaseUrl } from '../helpers/rulesApiHelpers';

export function fetchTenantStores() {
  return async (dispatch) => {
    dispatch({ type: RULES_STORES_FETCH_REQUEST });
    try {
      const url = await getBaseUrl();
      const headers = await getAuthHeaders();
      const response = await axios.get(`${url}/api/v1/rules_engine/stores`, { headers });
      const stores = Array.isArray(response.data)
        ? response.data
        : (response.data?.stores || []);
      dispatch({ type: RULES_STORES_FETCH_SUCCESS, payload: stores });
      return { success: true, stores };
    } catch (error) {
      const message = error?.message || 'Failed to load stores';
      dispatch({ type: RULES_STORES_FETCH_FAILURE, payload: message });
      return { success: false, error: message };
    }
  };
}
